// extracted by mini-css-extract-plugin
module.exports = {"map-switch-section":"MapSwitch_map-switch-section__YvuX2"};